import { throttle } from './ThrottleDebounce.js';


const $scrollSections = $('.js-scroll-section');
let $scrollWrapper = App.mobile ? App.B : App.W;
let scrollPosArr = [];
let isScrolling = false;


function scrollingSection() {
    //let scrollTop = App.B.scrollTop();
    let scrollTop = $scrollWrapper.scrollTop();
    let needIndex = 0;

    for (let i = 0; i < scrollPosArr.length; i++) {
        if (scrollTop < scrollPosArr[i]) {
            break;
        }

        needIndex = i;
    }

    if (!isScrolling ) {
        $('.js-fix-nav-item').removeClass('_active')
            .eq(needIndex)
            .addClass('_active');
    }
}

function generateScrollNav() {
    let _items = '';

    /*if ($scrollSections.length === 1) {
        return false;
    }*/

    $scrollSections.each(function (index, el) {
        let _title = $(el).data('title');

        _items += `
            <div class="fix-navigation__item js-fix-nav-item" data-index="${index}">
                <div class="fix-navigation__item-circle"></div>
                <div class="fix-navigation__item-label">${_title}</div>
            </div>
        `;
    });

    App.B.append(`
        <div class="fix-navigation">
            ${_items}                    
        </div>
    `);

    setScrollPositions();
    $('.js-fix-nav-item').eq(0).addClass('_active');
}

function setScrollPositions() {
    //const diff = App.mobile || App.mainpage ? 0 : 100;
    //const currScrollState = $('html, body').scrollTop;

    scrollPosArr = [];

    $scrollSections.each(function (index, el) {
        /*if (App.H.hasClass('page-main') && !App.mobile) {
            scrollPosArr.push($(el).offset().left * 1.04);
        }*/

        //if (!App.H.hasClass('page-main') || App.mobile) {
            //scrollPosArr.push($(el).offset().top - diff);
            scrollPosArr.push($(el).offset().top);
        //}
        //scrollPosArr.push($(el).offset().top - diff);
    });

    getHashParams();

    /*setTimeout(function () {
        $('html, body').animate({scrollTop: currScrollState}, 2);
    }, 300);*/
}


//App.B.on('scroll', throttle(scrollingSection, 50));

if ($scrollSections.length > 1) {
    $scrollWrapper.on('scroll', throttle(scrollingSection, 50));
    App.W.on('resize', throttle(setScrollPositions, 300));

    App.D.on('click', '.js-fix-nav-item', function () {
        let currIndex = $(this).data('index');
        //let currScroll = $scrollSections.eq(currIndex).offset().top;
        let currScroll = scrollPosArr[currIndex] - $('.js-header').outerHeight() - 51;
        isScrolling = true;

        $('html, body').animate({scrollTop: currScroll}, 500, function () {
            setTimeout(function () {
                isScrolling = false;

                $('.js-fix-nav-item').removeClass('_active')
                    .eq(currIndex)
                    .addClass('_active');
            }, 150);
        });
    });

    setTimeout(function () {
        generateScrollNav();
    }, 1000);
}

function getHashParams() {
    let hashParam = window.location.href.split('#')[1];

    if (hashParam && $(`[data-js-anchor="#${hashParam}"]`).length) {
        let $scrollWrap = $(`[data-js-anchor="#${hashParam}"]`);
        let scrollTop = $scrollWrap.offset().top;

        if (App.H.hasClass('page-main') && !App.mobile) {
            scrollTop = $scrollWrap.offset().left;
        }

        $('html, body').animate({
            scrollTop: scrollTop
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./_src/js/modules/ScrollNavigation.js